import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import SkeletonAdMediaThumbnail from '../../reusablePreviewComponents/SkeletonAdMediaThumbnail'
import FacebookVideoPreview from './FacebookVideoPreview'

import {
  FILE_NAME,
  FILE_URL,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../forms/ReusableFormFields/AdFileUpload/fields'

import { singleAdThumbnailHeight } from '../FacebookSingleMediaAdFooter/styles'
import useStyles from './styles'

const FacebookSingleMediaAdThumbnail = ({
  viewAdOnFacebook,
  mediaFile,
  isInProgress = false,
  mediaThumbnailImageRatio
}) => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false)

  const {
    [MEDIA_TYPE]: mediaType = 'image',
    [FILE_NAME]: fileName = '',
    [FILE_URL]: mediaUrl = '',
    [VIDEO_PICTURE]: videoPicture
  } = mediaFile

  const stylesProps = useMemo(
    () => ({
      height: isMediaLoaded ? 'auto' : singleAdThumbnailHeight,
      mediaType
    }),
    [isMediaLoaded, mediaType]
  )

  const classes = useStyles(stylesProps)

  const showSkeleton = useMemo(
    () => (mediaType === 'image' && !mediaUrl) || (mediaType === 'video' && !videoPicture) || !mediaType,
    [mediaType, mediaUrl, videoPicture]
  )

  const handleMediaSuccessfullyLoaded = useCallback(() => {
    setIsMediaLoaded(true)
  }, [])

  // We need isMediaLoaded to define thumbnail height.
  // When user delete media clear isMediaLoaded
  useEffect(() => {
    if (!mediaUrl && !videoPicture) {
      setIsMediaLoaded(false)
    }
  }, [mediaUrl, videoPicture])

  if (showSkeleton) {
    return (
      <SkeletonAdMediaThumbnail
        isInProgress={isInProgress}
        mediaPreviewHeight={singleAdThumbnailHeight}
        fileName={fileName}
        className={classes.adMedia}
      />
    )
  }

  return (
    <div className={classes.adMedia}>
      {mediaType === 'image' ? (
        <img onLoad={handleMediaSuccessfullyLoaded} src={mediaUrl} alt="Media preview" />
      ) : (
        <FacebookVideoPreview
          mediaFile={mediaFile}
          onLoad={handleMediaSuccessfullyLoaded}
          className={classes.videoPreviewContainer}
          viewAdOnFacebook={viewAdOnFacebook}
          mediaThumbnailImageRatio={mediaThumbnailImageRatio}
        />
      )}
    </div>
  )
}

FacebookSingleMediaAdThumbnail.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  mediaFile: PropTypes.shape({
    [MEDIA_TYPE]: PropTypes.string,
    [FILE_NAME]: PropTypes.string,
    [FILE_URL]: PropTypes.string,
    [VIDEO_PICTURE]: PropTypes.string
  }),
  isInProgress: PropTypes.bool,
  mediaThumbnailImageRatio: PropTypes.number
}

export default FacebookSingleMediaAdThumbnail
